import Vue from 'vue'
import axios from 'axios'

import errorProcessor, { VueErrorProcessorPlugin } from '@frontend/ll-fe-tracker/errorProcessor'
import globalErrorHandler from '@frontend/ll-fe-tracker/errorProcessor/handlers/global'
import axiosErrorHandler from '@frontend/ll-fe-tracker/errorProcessor/handlers/axios'
import * as ClientSentry from '@sentry/browser'

Vue.config.errorHandler = globalErrorHandler

axios.interceptors.response.use((response) => response, axiosErrorHandler)
Vue.use(VueErrorProcessorPlugin, {
  distributors: [
    {
      type: 'sentry',
      instance: ClientSentry,
    },
    ...(process.env.NUXT_ENV_ENV_NAME !== 'production'
      ? [
          {
            type: 'console',
          },
        ]
      : []),
  ],
  notifiers: [
    {
      notifyUser() {
        // 2 params
        // @message: error message as string
        // @application: Vue app instance
        // Showing a global toaster to show the error to user
      },
    },
  ],
})

export default (context, inject) => {
  inject('errorProcessor', errorProcessor)
}
